
import { defineComponent, ref } from "vue";
import { footerWidthFluid } from "@/core/helpers/config";
import { asideTheme, brandLightLogo, brandDarkLogo, } from "@/core/helpers/config";

export default defineComponent({
  name: "KTFooter",
  setup() {
    const web_fedup = ref(process.env.VUE_APP_WEB)
    const version = ref(process.env.VUE_APP_VERSION)
    const appName = ref(process.env.VUE_APP_NAME)
    return {
      footerWidthFluid,
      web_fedup,
      version,
      appName,
      asideTheme, brandLightLogo, brandDarkLogo,
    };
  },
});
